import React from 'react'
import Layout from '../../components/Layout/index'
import Logo from '../../assets/images/logo.png'

export default function Root() {
	return (
		<Layout>
			<div className="flex justify-center items-center h-[calc(100vh-80px)]">
				<img src={Logo} alt="Icomfort Logo" className="h-[150px] w-fit" />
			</div>
		</Layout>
	)
}
